// src/config/api.js
const API_BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:8000'

export default API_BASE_URL
